Namespace 'Common.Dashboard.Filters'

class Common.Dashboard.Filters.AppliedFiltersView extends Backbone.View
  template: JST['backbone/templates/common/dashboard/filters/applied/applied_filters']
  className: 'applied-filters'

  events:
    'click .remove-filters': 'unapplyAll'

  initialize: ({session, isReadOnly = false, filtersFactory}) ->
    @session = session
    @filtersFactory = filtersFactory
    @isReadOnly = isReadOnly
    @filterViews = []

  render: ->
    @$el.empty().append @template()
    $list = @$('.applied-filters-list')
    $list.append(filterView.render().el) for filterView in @_filterViews()
    @_markAsReadonly()
    @

  _markAsReadonly: ->
    @$('.remove-filters').addClass('hidden') if @isReadOnly
    @$('.content-filters-header').addClass('hidden') if @isReadOnly
    @$el.addClass('mini-scrollbar') if @isReadOnly

  _filterViews: ->
    filterView.remove() for filterView in @filterViews
    @filterViews = []
    for filter in @_filtersToRender()
      appliedFilterView = @_getAppliedFilterView(filter)
      @listenTo(appliedFilterView, 'filter:remove', @_modifyFilter)
      @listenTo(appliedFilterView, 'filter:value:remove', @_modifyFilter)
      @listenTo(appliedFilterView, 'filters:apply', (filter) => @trigger('filters:apply', filter))
      @filterViews.push(appliedFilterView)
    @filterViews

  _filtersToRender: ->
    @session.getCompositeFilter().getFilters()

  _getAppliedFilterView: (filter) ->
    @filtersFactory.getAppliedView(filter)

  _updateCompositeFilter: (newCompositeFilter) =>
    @session.setCompositeFilter(newCompositeFilter)
    @session.updateFilters()

  _modifyFilter: (modifyFunction) =>
    compositeFilter = @session.getCompositeFilter()
    modifyFunction(compositeFilter)
    @_updateCompositeFilter(compositeFilter)

  unapplyAll: =>
    compositeFilter = @session.getCompositeFilter()
    unless compositeFilter.onlyHasDefaultFilter()
      compositeFilter.removeAllFilters()
      @_updateCompositeFilter(compositeFilter)
